export default "__VITE_ASSET__8c56033c__"